import React from "react";
import { Redirect, Route, Router, Switch } from "react-router";
import { BrowserRouter } from "react-router-dom";
/* eslint-disable */
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
/* eslint-enable */
import PrivateRoute from "./PrivateRoute";
import { UnauthorizedOnlyRoute } from "./UnauthorizedOnlyRoute";
import * as routes from "./routes";
import history from "./history";

import Main from "../screens/Main";
// import Clients from "../screens/Clients";
import Audiences from "../screens/Audience";
import AudienceCreateFromTemplate from "../screens/Audience/CreateFromTemplate";
import AudiencesCreateWithoutTemplate from "../screens/Audience/CreateWithoutTemplate/CreateWithoutTemplate";

import FullReport from "../screens/Audience/FullReport";
import PDFReport from "../screens/PDFReport";

import SignIn from "../screens/Auth/SignIn";
// import SignUp from "../screens/Auth/SignUp";
import ResetPassword from "../screens/Auth/ResetPassword";
import RestorePassword from "../screens/Auth/RestorePassword";
import ActivateAccount from "../screens/Auth/ActivateAccount";

// import AccountPlan from "../screens/Account/Payment";
// import AccountUpgrade from "../screens/AccountUpgrade";
import AccountPlofile from "../screens/Account/AccountProfile";
import AccountOverview from "../screens/Account/AccountOverview";
import ClientActivities from "../screens/Account/ClientActivities";
import CRM from "../screens/CRM";
import Trash from "../screens/Trash/Trash";

import RedirectAdformSignin from "../components/redirects/RedirectAdformSignin";

// The guide is temporarily disabled
// import Guide from "../screens/Guide";
import ApiAccess from "../screens/ApiAccess";

// Permissions
import { permissions } from "../components/permissions";

// Platforms
import { PLATFORMS } from "../screens/Audience/PushModal/platforms";

const NotificationsWrapper = (Component, props) => {
  return (
    <>
      <Component {...props} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default function RouterController() {
  return (
    <BrowserRouter>
      <Router history={history}>
        <Switch>
          <Route exact path={routes.main} component={Main} />
          <UnauthorizedOnlyRoute
            exact
            path={routes.signIn}
            component={SignIn}
          />
          {/* <UnauthorizedOnlyRoute
            exact
            path={routes.signUp}
            component={SignUp}
          /> */}
          {/* <UnauthorizedOnlyRoute
            exact
            path={routes.signUpInvite}
            component={ActivateScreen}
          /> */}
          <Route
            exact
            path={routes.resetPassword}
            component={() => NotificationsWrapper(ResetPassword)}
          />
          <Route
            exact
            path={routes.restorePassword}
            component={props => NotificationsWrapper(RestorePassword, props)}
          />
          <UnauthorizedOnlyRoute
            path={routes.activateAccount}
            component={props => NotificationsWrapper(ActivateAccount, props)}
          />
          <PrivateRoute
            exact
            path={routes.clients("")}
            component={props => NotificationsWrapper(AccountOverview, props)}
            allow={permissions.clientSection.view}
          />

          <PrivateRoute
            path={routes.crm}
            component={props => NotificationsWrapper(CRM, props)}
          />

          <PrivateRoute
            exact
            path={routes.audiencesCreate}
            component={props =>
              NotificationsWrapper(AudienceCreateFromTemplate, props)
            }
            allow={permissions.audienceBuilder.view}
          />

          <PrivateRoute
            path={routes.audiencesCreateWithoutTemplate("")}
            component={props =>
              NotificationsWrapper(AudiencesCreateWithoutTemplate, props)
            }
            allow={permissions.audienceBuilder.view}
            redirectTo={routes.audiences("")}
          />

          <PrivateRoute
            path={routes.audiences("")}
            component={props => NotificationsWrapper(Audiences, props)}
          />
          <PrivateRoute
            path={routes.trash}
            component={props => NotificationsWrapper(Trash, props)}
          />
          <PrivateRoute
            // exact
            path={routes.fullReport}
            component={props => NotificationsWrapper(FullReport, props)}
            allow={permissions.preCampaignReport.view}
            redirectTo={routes.audiences("")}
          />
          <PrivateRoute
            withOutSidebar
            path={routes.fullReportPdf()}
            component={props => NotificationsWrapper(PDFReport, props)}
          />

          {/* <PrivateRoute
            path={routes.accountUpgrade}
            component={AccountUpgrade}
          /> */}
          <PrivateRoute
            path={routes.accountProfile}
            component={props => NotificationsWrapper(AccountPlofile, props)}
          />

          <PrivateRoute
            path={routes.clients("")}
            component={props => NotificationsWrapper(ClientActivities, props)}
          />

          <PrivateRoute
            path="/adform"
            platform={PLATFORMS.adform}
            component={props =>
              NotificationsWrapper(RedirectAdformSignin, props)
            }
          />
          <PrivateRoute
            path="/snapchat"
            platform={PLATFORMS.snapchat}
            component={props =>
              NotificationsWrapper(RedirectAdformSignin, props)
            }
          />
          <PrivateRoute
            path={routes.guide}
            render={() => <Redirect to={routes.audiences("")} />}
          />
          <PrivateRoute
            path={routes.apiAccess}
            component={props => NotificationsWrapper(ApiAccess, props)}
          />
          <Redirect to="/" />
        </Switch>
      </Router>
    </BrowserRouter>
  );
}
